import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { selectHasNonPinnedVariables, selectHasPinnedVariables } from '@ff-scene-plugins/gift-redux/slices/variablesSlice';
import { GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import { selectHasMultiplePrefabs } from '../../_redux-prefabs';
import { GiftWindowSteps, selectComponentForStep, useButtonText, useSteps } from '../shared/giftWindowSteps';

const _GiftWindowCompositionDesktop = ({ onClose, steps }: Props) => {

    const { step, next, previous } = useSteps(steps);

    const previousButtonText = useButtonText(steps[step - 1], 'previous', 'long');
    const nextButtonText = useButtonText(steps[step + 1], 'next', 'long');

    const CurrentStep = selectComponentForStep(steps[step]);

    return (
        <CurrentStep
            next={next} nextButtonText={nextButtonText}
            previous={previous} previousButtonText={previousButtonText}
            onClose={onClose} />
    );
};

type Props = {
    onClose: () => void;
    steps: GiftWindowSteps[];
};

const mapStateToProps = (state: GiftPdpState) => ({
    steps: selectSteps(state)
});

export const GiftWindowCompositionDesktop = connect(
    mapStateToProps
)(_GiftWindowCompositionDesktop);

const selectSteps = createSelector([
    selectHasPinnedVariables,
    selectHasMultiplePrefabs,
    selectHasNonPinnedVariables
], (hasPinnedVariables, hasPrefabs, hasNonPinnedVariables) => [
    (hasPinnedVariables || hasPrefabs) && 'design',
    hasNonPinnedVariables && 'non-pinned-variables',
    'overview'
].filter(Boolean) as GiftWindowSteps[]);